import type { ZudokuConfig } from "zudoku";
import { Landingpage } from "./src/Landingpage";

const config: ZudokuConfig = {
  site: {
    title: "Documentation",
    logo: {
      src: { light: "/pintcards-dark.png", dark: "pintcards-light.png" },
      alt: "Finstack",
      width: "130px",
      href: "/"
    },
    showPoweredBy: false,
    footer: {
      copyright: `© ${new Date().getFullYear()} Pintcards, Inc. All rights reserved.`,
      logo: {
        src: {
          light: "/pintcards-dark.png",
          dark: "/pintcards-light.png",
        },
        alt: "Pintcards",
        width: 120,
      },
    }
  },
  navigation: [
    {
      type: "custom-page",
      path: "/",
      element: <Landingpage />,
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/Finstack-cards.json",
      path: "/api",
      options: {
        examplesLanguage: "shell", // Default language for code examples
        disablePlayground: true, // Disable the interactive API playground
        disableSidecar: false, // Disable the sidecar completely
        showVersionSelect: "if-available", // Control version selector visibility
        expandAllTags: false, // Control initial expanded state of tag categories
      
      },
    },
  ],
  metadata: {
    title: "Documentation",
    logo: "/pintcards-dark.png",
    favicon: "/pintcards-icon-white-nobg.png",
    applicationName: "Documentation",
    referrer: "no-referrer",
    keywords: ["pintcards documentation"],
    authors: ["Pintcards developers"],
    creator: "Pintcards",
    publisher: "Pintcards"
  },
  
};

export default config;
